import React, { useCallback } from 'react';
import { connect } from 'redux-bundler-react';
import { handleKeyboardAction } from '@src/utils/keyboard';
import { mdiAlertCircle, mdiHelpCircle } from '@mdi/js';
import classnames from 'classnames';
import { useModal } from '@stores';
import { MarkdownRenderer } from '@src/app-components/markdown-renderer/MarkdownRenderer';

import Icon from '@components/icon/Icon';

import './tooltip.scss';
import tooltipModal from './tooltipModal';

const iconSizes = {
  small: '14px',
  medium: '16px',
  large: '18px',
  'x-large': '28px',
};

const getContentLength = (content) => {
  if (typeof content === 'string') {
    return content.length;
  } else {
    let length = 0;

    React.Children.forEach(content, (child) => {
      if (typeof child === 'string') {
        length += child.length;
      } else if (React.isValidElement(child) && (child.props.children || child.props.content)) {
        length += getContentLength(child.props.children || child.props.content);
      }
    });
    return length;
  }
};

const DisplayIcon = ({ onClick, onKeyUp, iconSize, isError, title }) => {
  const iconPath = isError ? mdiAlertCircle : mdiHelpCircle;
  const className = classnames('info-tooltip-icon', {
    'info-tooltip-error': isError,
  });

  return (
    <span id='help-icon'>
      <Icon
        aria-label={title}
        className={className}
        onClick={onClick}
        onKeyUp={onKeyUp}
        path={iconPath}
        size={iconSizes[iconSize] || iconSizes.medium}
        tabIndex={0}
        title={title}
      />
    </span>
  );
};

const Tooltip = connect(({ content, header, iconSize = 'medium', isError, title = 'view more information' }) => {
  const { openSecondaryModal } = useModal();
  const handleTooltipOpen = useCallback(() => {
    const contentLength = getContentLength(content);
    if (!contentLength) return;

    openSecondaryModal(tooltipModal, {
      isError: isError,
      msg: <MarkdownRenderer text={content} />,
      size: 'md',
      title: header,
    });
  }, [content, openSecondaryModal, header, isError]);
  const handleKeyUp = (e) => handleKeyboardAction(e, handleTooltipOpen);

  return (
    <DisplayIcon
      iconSize={iconSize}
      isError={isError}
      onClick={handleTooltipOpen}
      onKeyUp={handleKeyUp}
      title={title}
    />
  );
});

export default Tooltip;
